import * as React from "react";
import { AppContext } from "@1js/acui-context";
import { checkExperiment, ribbonExperiments } from "@1js/acui-experiments";

export const useNextContextMenuEnabled = (_id?: string) => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.fluentV9ContextMenuIsEnabled
  );
};

export const useNextFloatieEnabled = (_id?: string) => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.fluentV9FloatieIsEnabled
  );
};

export const useV9MenuAutoDismissFixEnabled = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.v9MenuAutoDismissFixEnabled
  );
};

export const useKeytipsForV9MenuItemsEnabled = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.isKeytipsForV9MenuItemsEnabled
  );
};

export const useFixOnMenuOpenedTriggerOnSubmenuHoverEnabled = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.fixOnMenuOpenedTriggerOnSubmenuHover
  );
};

export const useDispatchOptimizationEnabled = () => {
  // When this CG is enabled, the V9 Menu is not removed from the DOM on dismiss.
  // Rather, it stays in the DOM with toggled visibility. This is aimed to optimize rendering performance of CM.
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.isFluentV9DispatchOptimizationEnabled
  );
};

export const useTriggerOnMenuDismissedOnSubmenuClose = () => {
  // When this CG is enabled, onMenuDismissed cb is fired whenever a submenu closes.
  // This is to ensure that the react modal div no more remains visible in the DOM. VSO - 8990579
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.triggerOnMenuDismissedOnSubmenuClose
  );
};
